import { format, formatDistanceToNow, isToday, isYesterday, parseISO } from 'date-fns';

// Helper to safely parse dates
const safeParseDate = (date: Date | string | null | undefined): Date | null => {
  if (!date) return null;
  try {
    return typeof date === 'string' ? parseISO(date) : date;
  } catch (error) {
    console.error('Invalid date:', date);
    return null;
  }
};

export const formatDate = (date: Date | string | null | undefined): string => {
  const parsedDate = safeParseDate(date);
  if (!parsedDate) return 'Invalid date';

  if (isToday(parsedDate)) return `Today at ${format(parsedDate, 'h:mm a')}`;
  if (isYesterday(parsedDate)) return `Yesterday at ${format(parsedDate, 'h:mm a')}`;
  return format(parsedDate, 'MMM d, yyyy');
};

export const formatRelativeTime = (date: Date | string | null | undefined): string => {
  const parsedDate = safeParseDate(date);
  if (!parsedDate) return 'Invalid date';
  
  try {
    return formatDistanceToNow(parsedDate, { addSuffix: true });
  } catch (error) {
    console.error('Error formatting relative time:', error);
    return formatDate(parsedDate);
  }
};

export const formatTime = (date: Date | string | null | undefined): string => {
  const parsedDate = safeParseDate(date);
  if (!parsedDate) return 'Invalid time';
  return format(parsedDate, 'h:mm a');
};

export const formatDateTime = (date: Date | string | null | undefined): string => {
  const parsedDate = safeParseDate(date);
  if (!parsedDate) return 'Invalid date/time';
  return format(parsedDate, 'MMM d, yyyy h:mm a');
};